const commonStyles = {
  display: 'flex',
  flexDirection: 'row',
  height: '48px',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '8px',
  padding: '8px 0',
  position: 'relative',
  //overflow: 'hidden',
  cursor: 'pointer',
}

const beforeStyles = {
  content: '""',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  opacity: 0,
  transition: 'opacity 0.3s ease-in-out',
  zIndex: 0,
  pointerEvents: 'none',
}

const styles = theme => ({
  standAloneCoverDiv: {
    ...commonStyles,
    marginBottom: '8px',
    '&::before': {
      ...beforeStyles,
      borderRadius: '8px',
    },
    '&:hover::before': {
      opacity: 1,
    },
  },

  standAloneEndingDiv: {
    ...commonStyles,
    marginTop: '8px',
    '&::before': {
      ...beforeStyles,
      backgroundImage: `url('/assets/ending-open.svg')`,
      borderRadius: '8px',
    },
    '&:hover::before': {
      opacity: 1,
    },
    '&:hover $pageText, &:hover $icons': {
      color: '#fff',
    },
  },

  activePage: {
    '&::before': {
      opacity: '1 !important',
    },
  },

  contentWrapper: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
    transition: 'justify-content 0.225s',
  },
  iconContent: {
    display: 'flex',
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageText: {
    fontSize: '14px',
    fontWeight: 500,
  },

  icons: {
    marginTop: '3px',
    transition: 'color 0.3s ease-in-out',
  },

  FG: {
    flexGrow: 1,
  },
})

export default styles
